<div class="container mt-4">
  <h2 class="mb-4 text-center">📍 Pending Collections</h2>

  <div *ngIf="isLoading" class="text-center my-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <div *ngIf="!isLoading && pendingLocations.length > 0">
    <div class="row g-3">
      <div class="col-md-6 col-lg-4" *ngFor="let location of pendingLocations">
        <div class="card shadow-sm h-100 border-primary border-1">
          <div class="card-body">
            <h5 class="card-title text-primary fw-bold mb-2">
              {{ location.locationName || 'Unnamed Location' }}
            </h5>
            <p class="card-text text-muted mb-3">
              {{ location.businessAddress?.streetAddress1 || '' }}<br />
              <ng-container *ngIf="location.businessAddress?.streetAddress2">
                {{ location.businessAddress?.streetAddress2 }}<br />
              </ng-container>
              {{ location.businessAddress?.city || '' }},
              {{ location.businessAddress?.state || '' }}
              {{ location.businessAddress?.zipCode || '' }}
            </p>
            <button class="btn btn-outline-primary w-100" (click)="openCollectionModal(location.id)">
              🧾 Generate Collection
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!isLoading && pendingLocations.length === 0" class="alert alert-warning text-center mt-4">
    No pending locations assigned to you this month.
  </div>
</div>
